export const ViewProperty = "viewProperty";